'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ToolbarRadioGroup", {
    enumerable: true,
    get: function() {
        return ToolbarRadioGroup;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _ToolbarGroup = require("../../ToolbarGroup");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const ToolbarRadioGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _ToolbarGroup.useToolbarGroup_unstable)({
        role: 'radiogroup',
        ...props
    }, ref);
    (0, _ToolbarGroup.useToolbarGroupStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useToolbarGroupStyles_unstable')(state);
    return (0, _ToolbarGroup.renderToolbarGroup_unstable)(state);
// Casting is required due to lack of distributive union to support unions on @types/react
});
ToolbarRadioGroup.displayName = 'ToolbarRadioGroup';
